// Copyright (c) Docugami, Inc. All rights reserved.

import { ProviderId } from "networking/StorageProviders"
import { getIconForStorageProvider, getProviderFriendlyName } from "storage/StorageProviderHelpers"
import { SourcePicker } from './SourcePicker'

interface DocSourcePickerProps {
    selectedId: ProviderId | null;
    onSelected: (id: ProviderId) => void;
}

export const DocSourcePicker = (props: DocSourcePickerProps): JSX.Element => {
    const providerItems = Object.values(ProviderId).map(id => {
        return {
            id: id,
            icon: getIconForStorageProvider(id, 100, 100, 100, 100),
            name: getProviderFriendlyName(id),
            isSelected: props.selectedId === id,
            onSelected: () => props.onSelected(id)
        };
    });

    return <SourcePicker items={providerItems} />
}
